import { Injectable, inject } from '@angular/core';
import { BaseApiService } from '@bo/ng-api';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TermsAccept, TermsContent } from '../../_interfaces/terms.interface';

@Injectable({
  providedIn: 'root',
})
export class TermsApiService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  // Slugs
  TERMS_SLUG = 'terms-and-conditions';
  PREPAID_TERMS_SLUG = 'prepaid-card-terms-and-conditions';
  PRIVACY_SLUG = 'privacy-policy';

  // Api urls
  URL_TERMS_DOCUMENT: string = `terms/document`;
  URL_TERMS_PREVIEW: string = `terms/preview`;
  URL_ACCEPT_ALL: string = `accept-all`;

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }
  /**
   * Accept all documents
   * @return Observable<TermsAccept>
   */
  acceptTermsAll(data: TermsAccept) {
    return this.http.post<TermsAccept>(this.getUrl([this.URL_TERMS_DOCUMENT, this.URL_ACCEPT_ALL], true), data);
  }

  /**
   * Get terms and conditions document
   * @return Observable<TermsAccept>
   */
  getTermsDocument() {
    return this.http.get<TermsContent>(this.getUrl([this.URL_TERMS_DOCUMENT, this.TERMS_SLUG], true));
  }

  /**
   * Get terms and conditions document
   * @return Observable<TermsAccept>
   */
  getPrepaidCardTermsDocument() {
    return this.http.get<TermsContent>(this.getUrl([this.URL_TERMS_DOCUMENT, this.PREPAID_TERMS_SLUG], true));
  }

  /**
   * Get Privacy Policy document
   * @return Observable<TermsAccept>
   */
  getPrivacyDocument() {
    return this.http.get<TermsContent>(this.getUrl([this.URL_TERMS_DOCUMENT, this.PRIVACY_SLUG], true));
  }

  /**
   Get Document Preview for Draft documents
   * @param id
   * @return Observable<TermsAccept>
   */
  getDocumentPreview(id: string) {
    return this.http.get<TermsContent>(this.getUrl([this.URL_TERMS_PREVIEW, id], true));
  }
}
